/**
 * Footer API Client - Singleton
 *
 * Centralizes all API calls for Footer module.
 * Uses Infrastructure's request helper.
 */

import { request } from '../../../Infrastructure'
import { subscribeToNewsletter } from '../queries'

import type { NewsletterResponse, NewsletterSubscriptionStatus } from '../types'

/**
 * Inner GraphQL data type (without errors wrapper)
 */
interface NewsletterGraphQLData {
  subscribeEmailToNewsletter: {
    status: NewsletterSubscriptionStatus
  }
}

/**
 * Footer API client singleton
 */
export const footerApi = {
  /**
   * Subscribe email to newsletter
   *
   * @param email - Email address to subscribe
   * @returns Newsletter subscription response (with data or errors)
   */
  subscribeToNewsletter: async (email: string): Promise<NewsletterResponse> => {
    const response = await request<NewsletterGraphQLData>(subscribeToNewsletter, { email })

    // request<T>() returns { data: T }, which matches NewsletterResponse success branch
    return { data: response.data }
  },
}
